import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly document: Document;

  constructor(@Inject(DOCUMENT) document: Document) {
    this.document = document;
  }

  setTheme(theme: { bgColor: string; bgImage: string }) {
    this.document.documentElement.style.setProperty('--bg-color', theme.bgColor);
    this.document.documentElement.style.setProperty('--bg-image', `url(${theme.bgImage})`);
  }

  clearTheme() {
    this.document.documentElement.style.removeProperty('--bg-color');
    this.document.documentElement.style.removeProperty('--bg-image');
  }
}
